import { create } from "zustand";

import { TBusinessEstablishment } from "@type/api/corporation/types";

type TBusinessEstablishmentStore = {
  selectedBusinessEstablishment?: Partial<TBusinessEstablishment>;
  onSetSelectedBusinessEstablishment: (
    selectedBusinessEstablishment?: Partial<TBusinessEstablishment>
  ) => void;
};

export const useBusinessEstablishmentStore =
  create<TBusinessEstablishmentStore>((set) => ({
    selectedBusinessEstablishment: undefined,
    onSetSelectedBusinessEstablishment: (selectedBusinessEstablishment) => {
      set({ selectedBusinessEstablishment });
    },
  }));
